import { TLanguage } from "@/interfaces";
import { IUserSettings } from "@/shared/user";

import { IState } from "../state";

export class Settings {
  static toggleDarkTheme(state: IState) {
    const newState = Object.assign({}, state);
    newState.settings.isDarkThemeOn = !newState.settings.isDarkThemeOn;

    return newState;
  }
  static toggleSidebar(state: IState) {
    const newState = Object.assign({}, state);
    newState.settings.isSidebarOpen = !newState.settings.isSidebarOpen;

    return newState;
  }
  static toggleSidebarOrder(state: IState) {
    const newState = Object.assign({}, state);
    newState.settings.isSidebarByVessel = !newState.settings.isSidebarByVessel;

    return newState;
  }
  static toggleSourceDataName(state: IState) {
    const newState = Object.assign({}, state);
    newState.settings.isSourceDataName = !newState.settings.isSourceDataName;

    return newState;
  }
  static changeLanguage(state: IState, lang: TLanguage) {
    const newState = Object.assign({}, state);
    newState.settings.language = lang;

    return newState;
  }
  static selectedVessel(state: IState, vessel: { id: string; name: string }) {
    const newState = Object.assign({}, state);
    newState.selectedVessel = vessel;

    return newState;
  }
  static userSettings(state: IState, settings: IUserSettings) {
    const newState = Object.assign({}, state);
    newState.user.settings = {
      ...newState.user.settings,
      ...settings,
    };

    return newState;
  }
}
